import { render, staticRenderFns } from "./PreviewMaterial.vue?vue&type=template&id=6b078b7e&"
import script from "./PreviewMaterial.vue?vue&type=script&lang=js&"
export * from "./PreviewMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports